<div class="message-wrapper">
  <div class="message-box">
    <h2>System Message</h2>
    <p>
      The System is offline...
    </p>
  </div>
</div>
